import './_swimlanes.scss';

import { node } from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'reactstrap';

function Swimlanes({ children, ...rest }) {
  return (
    <Container fluid {...rest}>
      <Row className="flex-nowrap">
        {React.Children.map(children, lane => (
          <Col>{lane}</Col>
        ))}
      </Row>
    </Container>
  );
}

Swimlanes.propTypes = {
  children: node,
};

Swimlanes.defaultProps = {
  children: null,
};

export default Swimlanes;
